import React, { useEffect, useState } from 'react';
import { Nav, Container, Row, Col, Button, Form, Dropdown, Tabs, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faChevronLeft, faGreaterThan, faGreaterThanEqual, faLessThan, faLessThanEqual, faList, faPlus } from '@fortawesome/free-solid-svg-icons';
import './Strategy.css';
import DecisionInputes from './DecisionInputs/DecisionInputs'
import decisionValues from "../decision.json";
import { useMyContext } from '../../context/MyContext';
import { updateEdge } from 'reactflow';

function DecisionItems(props) {

    const [activeSection, setActiveSection] = useState(1);
    const [decisionData, setDecisionData] = useState('');
    const [isUpdate, setIsUpdate] = useState(false);
    const [isInputUpdate, setIsInputUpdate] = useState(false);
    const [inputItems, setInputItems] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState({});
    const [conditionCnt, setConditionCnt] = useState(0);
    const [errorMsg, setErrorMsg] = useState("");
    const { decisionObject, setDecisionObject } = useMyContext();
    let templateData = decisionValues.templateData[props.decitionContent];
    let templateObj = decisionValues.templateObj;
    const [decisionValue, setDecisionValue] = useState({});
    const [inputObjId, setInputObjId] = useState(templateData['id' + props.dataObj?.id]['field_id'])

    const [currentTab, setCurrentTab] = useState(0); // Track current tab
    const [inputValues, setInputValues] = useState({});
    const [updateCheck, setUpdateCheck] = useState(true);
    useEffect(() => {
        setDecisionValue(decisionValue);
    }, [decisionValue])

    const [selectedInput, setSelectedInput] = useState(Object.keys(templateData['id' + props.dataObj.id])[1]);

    // Get the decision sentence for the current decision
    const getDecisionSentence = () => {
        const decisionItems = decisionValues.decitionData[props.decitionContent];
        const currentDecision = decisionItems.find(item => item.id === props.dataObj.id);
        return currentDecision ? currentDecision.value : '';
    };

    // Create clickable decision sentence with links matching tab names
    const getClickableDecisionSentence = () => {
        const sentence = getDecisionSentence();
        if (!sentence) return sentence;

        // Get tab names to match with sentence parts
        const tabNames = getTabNames(templateObj[inputObjId][0]); // Use first object for tab names
        
        // Create a map of field keys to their display names and tab indices
        const fieldMap = {};
        const templateObjArray = templateObj[inputObjId];
        
        // Map each field to its corresponding tab index
        Object.entries(templateData['id' + props.dataObj.id])
            .filter(([key]) => key !== 'field_id')
            .forEach(([key, value], fieldIndex) => {
                const displayName = value.split(",")[0];
                
                // Find which tab this field belongs to
                let tabIndex = 0;
                for (let i = 0; i < templateObjArray.length; i++) {
                    if (templateObjArray[i][key]) {
                        tabIndex = i;
                        break;
                    }
                }
                
                // Handle duplicate field names by adding field key to the map key
                const mapKey = displayName.toLowerCase();
                if (fieldMap[mapKey]) {
                    // If this field name already exists, create an array of fields
                    if (Array.isArray(fieldMap[mapKey])) {
                        fieldMap[mapKey].push({ 
                            key, 
                            tabIndex, 
                            displayName,
                            fieldIndex 
                        });
                    } else {
                        // Convert single field to array
                        fieldMap[mapKey] = [fieldMap[mapKey], { 
                            key, 
                            tabIndex, 
                            displayName,
                            fieldIndex 
                        }];
                    }
                } else {
                    fieldMap[mapKey] = { 
                        key, 
                        tabIndex, 
                        displayName,
                        fieldIndex 
                    };
                }
            });

        // Split sentence into parts and create clickable elements
        const parts = sentence.split(' ');
        const clickableParts = [];
        
        // Create a map for multi-word phrases
        const phraseMap = {};
        Object.entries(fieldMap).forEach(([key, value]) => {
            const words = key.split(' ');
            if (words.length > 1) {
                phraseMap[key] = value;
            }
        });
        
        let i = 0;
        while (i < parts.length) {
            let matchedField = null;
            let matchedLength = 1;
            
            // First check for multi-word phrases
            for (const [phrase, field] of Object.entries(phraseMap)) {
                const phraseWords = phrase.split(' ');
                const canMatch = i + phraseWords.length <= parts.length;
                
                if (canMatch) {
                    const sentencePhrase = parts.slice(i, i + phraseWords.length)
                        .map(word => word.toLowerCase().replace(/[.,!?;:]/g, ''))
                        .join(' ');
                    
                    if (sentencePhrase === phrase) {
                        matchedField = field;
                        matchedLength = phraseWords.length;
                        break;
                    }
                }
            }
            
            // If no multi-word phrase found, check for single word
            if (!matchedField) {
                const cleanPart = parts[i].toLowerCase().replace(/[.,!?;:]/g, '');
                matchedField = fieldMap[cleanPart];
                matchedLength = 1;
            }
            
            if (matchedField) {
                let fieldToUse;
                let displayText;
                const matchedWords = parts.slice(i, i + matchedLength);
                
                if (Array.isArray(matchedField)) {
                    // Multiple fields with same name - use position in sentence to determine which field
                    // Find the field that corresponds to this position in the sentence
                    let fieldToUseIndex = 0;
                    
                    // Get the current phrase for comparison
                    const currentPhrase = matchedWords.join(' ').toLowerCase().replace(/[.,!?;:]/g, '');
                    
                    // Count how many times this phrase appears before the current position
                    let phraseCount = 0;
                    for (let j = 0; j < i; j++) {
                        const prevPhrase = parts.slice(j, j + matchedLength).join(' ').toLowerCase().replace(/[.,!?;:]/g, '');
                        if (prevPhrase === currentPhrase) {
                            phraseCount++;
                        }
                    }
                    
                    // Use the corresponding field based on occurrence count
                    fieldToUseIndex = Math.min(phraseCount, matchedField.length - 1);
                    fieldToUse = matchedField[fieldToUseIndex];
                    
                    const { data } = inputCheck(fieldToUse.key);
                    displayText = data !== null ? data : matchedWords.join(' ');
                } else {
                    // Single field
                    fieldToUse = matchedField;
                    const { data } = inputCheck(matchedField.key);
                    displayText = data !== null ? data : matchedWords.join(' ');
                }
                
                const { isValid } = inputCheck(fieldToUse.key);
                
                clickableParts.push(
                    <span key={`phrase-${i}`}>
                        <span
                            className={`decision-link ${isValid ? 'filled' : 'empty'}`}
                            onClick={() => setActiveTab(fieldToUse.tabIndex)}
                            style={{ 
                                cursor: 'pointer', 
                                fontWeight: '700',
                                backgroundColor: activeTab === fieldToUse.tabIndex ? '#fff3cd' : 'transparent',
                                padding: activeTab === fieldToUse.tabIndex ? '2px 4px' : '0',
                                borderRadius: activeTab === fieldToUse.tabIndex ? '4px' : '0',
                                transition: 'background-color 0.2s ease'
                            }}
                        >
                            {displayText}
                        </span>
                    </span>
                );
                
                // Add space after the phrase
                if (i + matchedLength < parts.length) {
                    clickableParts.push(
                        <span key={`space-${i}`} style={{ whiteSpace: 'pre' }}>
                            {' '}
                        </span>
                    );
                }
                
                i += matchedLength;
            } else {
                // No match found, add as regular text
                clickableParts.push(
                    <span key={`word-${i}`} style={{ fontWeight: '400', color: '#000000' }}>
                        {parts[i]}
                    </span>
                );
                
                // Add space after the word
                if (i < parts.length - 1) {
                    clickableParts.push(
                        <span key={`space-${i}`} style={{ whiteSpace: 'pre' }}>
                            {' '}
                        </span>
                    );
                }
                
                i++;
            }
        }

        return clickableParts;
    };

    // Show content for the active field
    const getActiveFieldContent = () => {
        if (templateObj[inputObjId] && templateObj[inputObjId][activeTab]) {
            const object = templateObj[inputObjId][activeTab];
            return (
                <div className="active-field-content">
                    {Object.entries(object).map(([key, value]) => (
                        <React.Fragment key={key}>
                            {(Object.keys(decisionValue).length > 0) && (
                                <DecisionInputes
                                    type={value}
                                    key={key}
                                    label={templateData['id' + props.dataObj.id][key]}
                                    decisionValue={decisionValue}
                                    setDecisionValue={setDecisionValue}
                                    index={key}
                                    mainIndex={'dt' + props.dataObj.id}
                                    selectedInput={selectedInput}
                                    openPositions={props.openPositions}
                                    tagNames={props.tagNames}
                                    isInputUpdate={isInputUpdate}
                                    setIsInputUpdate={setIsInputUpdate}
                                    activeTab={activeTab}
                                    setActiveTab={setActiveTab}
                                />
                            )}
                        </React.Fragment>
                    ))}
                </div>
            );
        }
        return null;
    };


    const cancelData = () => {
        props.hideFields(prevState => ({
            ...prevState,
            showFields: false
        }));
    }

    const saveData = () => {
        props.setExpandedL(false)
        let isValid = true;
        setErrorMsg("")
        Object.keys(decisionValue[Object.keys(decisionValue)[0]]).map((key) => {
            if (decisionValue[Object.keys(decisionValue)[0]][key] === null) {
                isValid = false;
                setErrorMsg("Fields cannot be blank!")
            }
        })
        if (isValid) {
            if ((props.clickStr == 'start' || props.clickStr == 'YES' || props.clickStr == 'NO') && props.type == 'decision') {
                let count = props.conditionCount + 1;
                props.setConditionCount(count);
                setConditionCnt(count);
                let json = {
                    ['CONDITION' + count]: {
                        TMP_ID: Object.keys(decisionValue)[0],
                        CONTENT: decisionValue[Object.keys(decisionValue)[0]],
                        YES: {},
                        NO: {},
                        // ID: props.clickStr == 'start' ? '1' : (props.clickStr == 'YES' ? decisionData.id + '.1' : decisionData.id + '.2')
                        ID: props.clickStr == 'start' ? '1' : (props.id)
                    },
                    TYPE: "CONDITION",
                    KEY: 'CONDITION' + count,
                }
                if (props.clickStr == 'start') {
                    props.setBuildJSON(json);
                    let updateCnt = (props.iterateCnt + 1);
                    props.setIterateCnt(updateCnt);
                    props.setParentNode(json['CONDITION' + updateCnt]);
                } else if (props.clickStr == 'YES') {
                    findAndUpdateObj(props, json, props.clickStr);
                } else if (props.clickStr == 'NO') {
                    findAndUpdateObj(props, json, props.clickStr);
                }
            }

            let obj = props.dataObj
            obj.showFields = false;
            setDecisionObject(obj);
            props.setIsUpdateJson(!props.isUpdateJson);
            setUpdateCheck(!updateCheck);
            // props.closeModal(true)
        }
    }

    const [checkedItems, setCheckedItems] = useState([selectedInput]);
    function findAndUpdateObj(obj, json, clickStr) {
        let updated = 0;
        function traverseTree(node, json, id, nodeType) {
            if (node == null) {
                return;
            }
            if (node[Object.keys(node)[0]]?.ID == id) {
                if (nodeType == 'YES') {
                    node[Object.keys(node)[0]]['YES'] = json;
                } else {
                    node[Object.keys(node)[0]]['NO'] = json;
                }
                return 0;
            }
            traverseTree(node[Object.keys(node)[0]]?.YES, json, id, clickStr);
            traverseTree(node[Object.keys(node)[0]]?.NO, json, id, clickStr);
        }
        let lastDotIndex = props.id.lastIndexOf(".");
        let desiredId = props.id.substring(0, lastDotIndex);
        traverseTree(obj.buildJSON, json, desiredId, clickStr);
        return obj;
    }
    useEffect(() => {
        setDecisionData(props.dataObj);
        setSelectedTemplate(templateObj['id' + props.dataObj.id]);
        setInputItems(templateObj['ft' + props.dataObj.id]);
        setIsUpdate(true)
    }, []);

    useEffect(() => {
        props.setIsUpdateJson(!props.isUpdateJson)
    }, [updateCheck]);

    useEffect(() => {
        setDecisionData(props.dataObj);
        setInputItems(templateObj['ft' + props.dataObj.id]);
        setSelectedTemplate(templateObj['id' + props.dataObj.id]);

        let objData = { ...decisionValue };
        for (let ind in templateData) {
            let regex = /(\d+)/g;
            let intVal = ind.match(regex);
            if (decisionData.id == intVal.join("")) {
                if (objData['dt' + decisionData.id] == undefined) {
                    const filteredObject = Object.keys(templateData[ind]).reduce((acc, key) => {
                        if (key !== 'field_id') {
                            acc[key] = templateData[ind][key];
                        }
                        return acc;
                    }, {});
                    objData['dt' + decisionData.id] = filteredObject
                    for (let key in objData['dt' + decisionData.id]) {
                        objData['dt' + decisionData.id][key] = null;
                    }
                }
            }
        }

        setDecisionValue(objData);
    }, [isUpdate, props])

    // const updateInput = (val) => {
    //     let items = checkedItems;
    //     items.push(val)
    //     setCheckedItems(items);
    //     setSelectedInput(val)
    // }

    const inputCheck = (index) => {
        if (decisionValue && Object.keys(decisionValue).length > 0) {
            const firstKey = Object.keys(decisionValue)[0];
            const keyValue = decisionValue[firstKey];
            if (keyValue && keyValue[index] === null) {
                return { isValid: false, data: null };
            }
            if (keyValue && keyValue[index] !== undefined) {
                return { isValid: true, data: keyValue[index] };
            }
        }
        return { isValid: false, data: null };
    };

    // const mappedElements = Object.entries(templateData['id' + props.dataObj.id])
    //     .filter(([key]) => key !== 'field_id')
    //     .map(([key, value]) => {
    //         const { isValid, data } = inputCheck(key);
    //         return (
    //             <span key={key} className={isValid ? 'item-checked' : ''}>
    //                 <span className={isValid ? 'item-selected' : ''}>
    //                     {data === null ? value.split(",")[0] : data}
    //                 </span>
    //             </span>
    //         );
    //     });

    const getTabNames = (object) => {
        // We will generate the names by splitting each string by commas and making separate tabs
        return Object.entries(templateData['id' + props.dataObj.id])
            .filter(([key]) => key !== 'field_id')
            .map(([key, value]) => {
                const { isValid, data } = inputCheck(key);
                const dataToUse = data === null ? value.split(",")[0] : data;
                return isValid ? dataToUse + '@#@1' : dataToUse + '@#@0';
            })
            .filter(name => name);  // Filter out any empty strings if any
    };


    const [activeTab, setActiveTab] = useState(0);

    return (
        <div className=" align-items-center">
            <Row>
                <Col md={9}>
                    {/* <Row className='text-left'>
                    <Col md={12}>
                        <span className='cursor-pointer primary-text decision-item-wrapper' style={{ cursor: 'pointer' }}>
                            <div>{mappedElements}</div>
                        </span>
                    </Col>
                </Row> */}

                    {/* Decision Sentence Label */}
                    <div className="decision-sentence-label mb-3">
                        <p className="decision-text fw-bold text-primary">
                            {getClickableDecisionSentence()}
                        </p>
                    </div>

                    {/* Active Field Content */}
                    <div className="active-field-container">
                        {getActiveFieldContent()}
                    </div>

                    {/* {templateObj[inputObjId].map((object, index) => (
                    <span key={index}>
                        {Object.entries(object).map(([key, value]) => (
                            <>
                                {(Object.keys(decisionValue).length > 0) && <DecisionInputes
                                    type={value}
                                    key={key}
                                    label={templateData['id' + props.dataObj.id][key]}
                                    decisionValue={decisionValue}
                                    setDecisionValue={setDecisionValue}
                                    index={key}
                                    mainIndex={'dt' + props.dataObj.id}
                                    selectedInput={selectedInput}
                                    openPositions={props.openPositions}
                                    tagNames={props.tagNames}
                                    isInputUpdate={isInputUpdate}
                                    setIsInputUpdate={setIsInputUpdate}
                                />}
                            </>
                        ))}
                    </span>
                ))} */}
                    {errorMsg !== '' && <p className='text-danger'>{errorMsg}</p>}

                </Col>

                <Col md={3}>
                    <div className="content-header-btn- d-flex gap-2 gap-xl-3">
                        <button className='btn' onClick={cancelData} >
                            Cancel
                        </button>
                        <button className='btn bg-primary' onClick={saveData} >
                            Save
                        </button>
                    </div>
                </Col>
            </Row>


            {/* <Col md={12}>
                {errorMsg !== "" && <p className='text-danger'>{errorMsg}</p>}
            </Col> */}
        </div>
    );
}

export default DecisionItems;

